import SegmentCreateCtrl from './controllers/create';
import SegmentShowCtrl from "./controllers/show";
import SegmentExportCtrl from "./controllers/export";
import segmentationSelectWithNegative from './directives/segmentationSelectWithNegative';
import segmentationSelect from "./directives/segmentationSelect";
import inputType from "./directives/inputType";
import SegmentRule from "./directives/segment-rule";
import CountRule from "./directives/count-rule";
import ConstraintRule from "./directives/constraint-rule";
import Segment from './segment.repository';
import inputOperator from "./directives/inputOperator";
import routing from './segment.routes';
import uirouter from 'angular-ui-router';
import suppressionRule from "./directives/suppression";
import FacebookService from "../facebook/facebook.service";
import Facebook from "../facebook/facebook.repository";
import SelectFbAccount from "./directives/select-fb-account";
import SelectGoogleAccount from "./directives/select-google-account";

export default angular.module('app.segment', [uirouter])
    .config(routing)
    .controller('SegmentCreateCtrl', SegmentCreateCtrl)
    .controller('SegmentShowCtrl', SegmentShowCtrl)
    .controller('SegmentExportCtrl', SegmentExportCtrl)
    .directive('segmentationSelectWithNegative', () => new segmentationSelectWithNegative)
    .directive('segmentationSelect', () => new segmentationSelect)
    .directive('inputType', () => new inputType)
    .directive('segmentRule', () => new SegmentRule)
    .directive('countRule', () => new CountRule)
    .directive('constraintRule', () => new ConstraintRule)
    .directive('inputOperator', () => new inputOperator)
    .directive('suppressionRule', () => new suppressionRule)
    .directive('selectFbAccount', () => new SelectFbAccount)
    .directive('selectGoogleAccount', () => new SelectGoogleAccount())
    .service('Segment', Segment)
    .service('FacebookService', FacebookService)
    .service('Facebook', Facebook)
    .name;

